<template>
<div v-if="dataLoaded && statusesLoaded" class="animated fadeIn">

  <b-row>
    <b-col>
      <h2 class="mb-3">User status</h2>
    </b-col>
  </b-row>

  <b-row>
    <b-col sm="12">
      <b-card>

        <b-row>
          <b-col>
            <b-form-group>
              <label for="status">Status</label>
              <b-form-select id="status" :options="statuses" v-model="applicationData.status_id"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="applicationData.status_id == rejectedStatusId">
          <b-col>
            <b-form-group>
              <label for="rejected_reason">Rejected reason</label>
              <b-form-textarea id="rejected_reason" :options="statuses" :rows="3" v-model="applicationData.rejected_reason">
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Notes <small>(visible only in admin panel)</small>" label-for="basicTextarea">
              <b-form-textarea v-model="applicationData.notes" id="basicTextarea" :rows="3" placeholder=""></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="form-group form-actions">
              <b-button @click.prevent="saveForm()" type="submit" variant="primary" ref="btn__save">Save</b-button>&nbsp;&nbsp;&nbsp;<span class="form-alert text-success" ref="alert__save"></span>
            </div>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>

  <b-row>
    <b-col>
      <h2 class="mb-3">User data</h2>
    </b-col>
  </b-row>

  <b-row>
    <b-col sm="6">
      <b-card>
        <div slot="header">
          <strong>Personal data</strong>
        </div>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="first_name">First name</label>
              <b-form-input v-model="applicationData.user.first_name" type="text" id="first_name" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="last_name">Last name</label>
              <b-form-input v-model="applicationData.user.last_name" type="text" id="last_name" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="email">E-mail address</label>
              <b-form-input v-model="applicationData.user.email" type="email" id="email" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="phone_number">Phone number</label>
              <b-form-input v-model="applicationData.user.phone" type="text" id="phone_number" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="address">Street</label>
              <b-form-input v-model="applicationData.user.street" type="text" id="address" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="city">House number</label>
              <b-form-input v-model="applicationData.user.house_number" type="text" id="city" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="city">Flat number</label>
              <b-form-input v-model="applicationData.user.flat_number" type="text" id="city" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="city">City</label>
              <b-form-input v-model="applicationData.user.city" type="text" id="city" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="postcode">Post code</label>
              <b-form-input v-model="applicationData.user.zip_code" type="text" id="postcode" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="administrative_region_1">Administrative region 1</label>
              <b-form-input v-model="applicationData.user.administrative_region_1" type="text" id="city" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="administrative_region_2">Administrative region 2</label>
              <b-form-input v-model="applicationData.user.administrative_region_2" type="text" id="postcode" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col sm="6">
      <b-card>
        <div slot="header">
          <strong>User agreements</strong>
        </div>

        <b-row>
          <b-col sm="2" class="d-flex align-items-center">
            <span v-if="applicationData.user.terms_agreement" class="badge badge-success agreement-badge d-flex align-items-center justify-content-center">YES</span>
            <span v-else class="badge badge-danger agreement-badge d-flex align-items-center justify-content-center">NO</span>
          </b-col>
          <b-col sm="10">
            <h3>Data processing agreement</h3>
            {{ applicationData.user.terms_agreement_text }}
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col sm="2" class="d-flex align-items-center">
            <span v-if="applicationData.user.electronic_agreement" class="badge badge-success agreement-badge d-flex align-items-center justify-content-center">YES</span>
            <span v-else class="badge badge-danger agreement-badge d-flex align-items-center justify-content-center">NO</span>
          </b-col>
          <b-col sm="10">
            <h3>Electronic agreement</h3>
            {{ applicationData.user.electronic_agreement_text }}
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col sm="2" class="d-flex align-items-center">
            <span v-if="applicationData.user.marketing_agreement" class="badge badge-success agreement-badge d-flex align-items-center justify-content-center">YES</span>
            <span v-else class="badge badge-danger agreement-badge d-flex align-items-center justify-content-center">NO</span>
          </b-col>
          <b-col sm="10">
            <h3>Marketing agreement</h3>
            {{ applicationData.user.marketing_agreement_text }}
          </b-col>
        </b-row>

      </b-card>
    </b-col>

  </b-row>

  <b-row>
    <b-col>
      <h2 class="mb-3">Registered Products</h2>
    </b-col>
  </b-row>

  <b-row>
    <b-col v-for="product in applicationData.registeredProducts" v-bind:key="product.id" sm="12">

      <b-card>
        <div slot="header">
          <strong>{{ product.name }} [{{ product.id }}]</strong>
        </div>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="first_name">Product name</label>
              <b-form-input v-model="product.name" type="text" id="first_name" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="last_name">Category</label>
              <b-form-input v-model="product.product_category.name" type="text" id="last_name" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="last_name">Serial number</label>
              <b-form-input v-model="product.serial_number" type="text" id="last_name" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="last_name">Date of purchase</label>
              <b-form-input v-model="product.purchase_date" type="text" id="last_name" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>

          <b-col sm="4">
            <b-form-group>
              <label for="last_name">Shop type</label>
              <b-form-input v-model="product.shop_type" type="text" id="last_name" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col v-if="product.shop_type === 'online'" sm="4">

            <b-row>
              <b-col>
                <b-form-group>
                  <label for="last_name">Online shop address</label>
                  <b-form-input v-model="product.shop_www" type="text" id="last_name" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

          </b-col>

          <b-col v-if="product.shop_type === 'stationary'" sm="8">

            <b-row>
              <b-col sm="6">
                <b-form-group>
                  <label for="last_name">Stationary shop name</label>
                  <b-form-input v-model="product.shop_name" type="text" id="last_name" disabled></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="6">
                <b-form-group>
                  <label for="last_name">Stationary shop address</label>
                  <b-form-input v-model="product.shop_address" type="text" id="last_name" disabled></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="6">
                <b-form-group>
                  <label for="last_name">Stationary shop postcode</label>
                  <b-form-input v-model="product.shop_zip_code" type="text" id="last_name" disabled></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="6">
                <b-form-group>
                  <label for="last_name">Stationary shop city</label>
                  <b-form-input v-model="product.shop_city" type="text" id="last_name" disabled></b-form-input>
                </b-form-group>
              </b-col>

            </b-row>

          </b-col>

        </b-row>

        <hr v-if="product.document_purchase_name || product.document_warranty_name" />
        <b-row>

          <b-col v-if="product.document_purchase_name" sm="3" class="text-center">
            <img :src="globalStore.API_BASE_URL + globalStore.RESOURCES_DIR + product.document_purchase_name" class="product-document-image img-fluid mb-2" alt="">
            <b-button @click.prevent="showImage(product.document_purchase_name)" block variant="primary">Show purchase document</b-button>
          </b-col>

          <b-col v-if="product.document_warranty_name" sm="3" class="text-center">
            <img :src="globalStore.API_BASE_URL + globalStore.RESOURCES_DIR + product.document_warranty_name" class="product-document-image img-fluid mb-2" alt="">
            <b-button @click.prevent="showImage(product.document_warranty_name)" block variant="primary">Show warranty card</b-button>
          </b-col>

        </b-row>

        <!-- <hr v-if="product.status_id" /> -->
        <!-- <b-row v-if="product.status_id"> -->
        <hr />
        <b-row>

          <b-col>
            <b-form-group>
              <label for="status">Status</label>
              <b-form-select id="status" :options="statuses" v-model="product.status_id"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- <b-row v-if="product.status_id && product.status_id == rejectedStatusId"> -->
        <b-row>
          <b-col>
            <b-form-group>
              <label for="rejected_reason">Rejected reason</label>
              <b-form-textarea id="rejected_reason" :options="statuses" :rows="3" v-model="product.rejected_reason"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Notes <small>(visible only in admin panel)</small>" label-for="basicTextarea">
              <b-form-textarea v-model="product.notes" id="basicTextarea" :rows="3" placeholder=""></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="form-group form-actions form-actions--save">
              <b-button @click.prevent="saveProduct(product)" type="submit" variant="primary" :ref="`btn__${product.id}`">Save</b-button>&nbsp;&nbsp;&nbsp;<span class="form-alert text-success" :ref="`alert__${product.id}`"></span>
            </div>
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>

</div>
</template>

<script>
import {
  Switch as cSwitch
} from '@coreui/vue'
import {
  globalStore
} from '@/main'

export default {
  name: 'application',

  data() {
    return {
      applicationData: [],
      dataLoaded: false,
      statusesLoaded: false,
      statuses: [],
      alert: '',
    }
  },
  computed: {
    rejectedStatusId() {
      if (this.statusesLoaded) {
        for (let i = 0; i < this.statuses.length; ++i) {
          if (this.statuses[i].text === 'Rejected') {
            return this.statuses[i].value;
          }
        }
      }
    },
    globalStore() {
      return globalStore;
    }
  },
  mounted() {
    this.loadApplicationData()
    this.loadStatuses()
    this.axios.defaults.headers.common['Implementation-Id'] = this.$store.getters.getActiveImplementation;
  },
  methods: {
    loadApplicationData() {
      let cmp = this
      cmp.axios.get(globalStore.API_BASE_URL + 'api/applications/' + this.$route.params.id).then((response) => {
        let responseData = response.data;
        console.error(response.data.data)
        if (responseData.code === 200) {
          cmp.applicationData = responseData.data
          cmp.dataLoaded = true
          // console.dir(cmp.applicationData)
        } else {
          alert('There was problem with fetch data from server.')
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    loadStatuses() {
      let cmp = this
      cmp.axios.get(globalStore.API_BASE_URL + 'statuses').then((response) => {
        let responseData = response.data
        // console.dir(responseData)
        if (responseData.code === 200) {
          responseData.data.forEach((el) => {
            cmp.statuses.push({
              value: el.id,
              text: cmp.formatterFirstLetterUC(el.status)
            })
          })
          cmp.statusesLoaded = true
        } else {
          alert('There was problem with fetch data from server.')
        }
      })
    },
    saveForm() {
      let cmp = this
      this.alert = 'Sending';
      this.$refs['btn__save'].disabled = true;

      cmp.axios.post(globalStore.API_BASE_URL + 'api/applications/update/' + this.$route.params.id, {
        status_id: this.applicationData.status_id,
        notes: this.applicationData.notes,
        rejected_reason: this.applicationData.rejected_reason,
      }).then((response) => {
        let responseData = response.data;

        if (responseData.code === 200) {
          this.$refs[`alert__save`].innerHTML = 'Data saved';
        } else {
          this.$refs[`alert__save`].innerHTML = 'There was problem with updating application data';
        }

        setTimeout(() => {
          this.$refs[`alert__save`].innerHTML = "";
          this.$refs[`btn__save`].disabled = false;
        }, 5000);

      })
    },
    saveProduct(product) {
      let cmp = this
      this.alert = 'Sending';
      this.$refs[`btn__${product.id}`][0].disabled = true;

      let alteredProduct = {
        id: product.id,
        status_id: product.status_id,
        rejected_reason: product.rejected_reason,
        notes: product.notes
      }

      console.dir(alteredProduct)

      cmp.axios.post(globalStore.API_BASE_URL + 'api/applications/updateproducts/' + this.$route.params.id, alteredProduct).then((response) => {
        let responseData = response.data;

        if (responseData.code === 200) {
          this.$refs[`alert__${product.id}`][0].innerHTML = 'Data saved';
        } else {
          this.$refs[`alert__${product.id}`][0].innerHTML = 'There was problem with updating application data';
        }

        setTimeout(() => {
          this.$refs[`alert__${product.id}`][0].innerHTML = "";
          this.$refs[`btn__${product.id}`][0].disabled = false;
        }, 5000);

      })

    },
    showImage(fileName) {
      window.open(this.globalStore.API_BASE_URL + this.globalStore.RESOURCES_DIR + fileName, '_blank')
    },
    formatterFirstLetterUC(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  components: {
    cSwitch
  }
}
</script>
